﻿import {IProgress} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import AttachmentType from "../enums/AttachmentType";
import IPermitsHttpClient from "../http/IPermitsHttpClient";
import {AttachmentFormData} from "./createPermitFromCommand";
import ensureProgress from "./ensureProgress";
import {ProgressReporter} from "./progressReporter";
import reportProgress from "./reportProgress";

export async function toFormData(httpClient: IPermitsHttpClient, attachments: Partial<Record<AttachmentType, FileList>> | undefined, progress?: IProgress, reporter?: ProgressReporter): Promise<AttachmentFormData[]> {
	if (attachments == null) return [];

	progress = ensureProgress(attachments, PermitTranslations.create_permit__upload_files, progress);
	reportProgress(progress, reporter);
	const result: AttachmentFormData[] = [];

	for (let [key, fileList] of Object.entries(attachments)) {
		let formData: FormData;
		if (fileList == null || fileList.length === 0) {
			continue;
		}

		if (fileList.length === 1) {
			formData = new FormData();
			formData.append("file", fileList[0]);

		} else {
			formData = new FormData();
			for (let i = 0, l = fileList.length; i < l; ++i) {
				formData.append("files", fileList[i]);
				++progress.current;
			}

			reportProgress(progress, reporter);
			const blob = await httpClient.files.mergeImages(formData);
			formData = new FormData();
			formData.append("file", blob);
		}

		result.push({
			data: formData,
			type: parseInt(key, 10) as AttachmentType
		});
	}

	return result;
}
